export const MIN_TOKEN_RENEWAL_BACKOFF_MS = 1_000;
export const MAX_TOKEN_RENEWAL_BACKOFF_MS = 30_000;

export function calculateTaskRealtimeRenewalDelay(
  expiresAt: number,
  nowMs: number,
  backoffMs: number,
): number {
  const delayUntilRenewalMs = Math.max(0, expiresAt * 1000 - nowMs - 60_000);
  if (delayUntilRenewalMs > 0) {
    return delayUntilRenewalMs;
  }
  return Math.min(
    Math.max(MIN_TOKEN_RENEWAL_BACKOFF_MS, backoffMs),
    MAX_TOKEN_RENEWAL_BACKOFF_MS,
  );
}
